module.exports = __webpack_public_path__ + "static/media/child-cute-dad-105952.c9f94fe1.jpg";